import { PropertyGroupSplitBy, PropertyGroupStep } from "../../types";
import { PropertyGroupSelector } from "./components/PropertyGroupSelector";
import { Dispatch, SetStateAction } from "react";
import { Card } from "shared/components/Card";
import { PropertyGroupChartLegendItems } from "views/property-groups-configuration/constants";
import { PropertyGroupsSankeyChart } from "views/property-groups-configuration/components/PropertyGroupsSankeyChart";
import { generateExampleSankeyData } from "./utils";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

export const InitialConfigurationSlice = ({
  selectedSplitOptions,
  setSelectedSplitOptions,
  enableOwnerSelection
}: {
  selectedSplitOptions: PropertyGroupSplitBy[];
  setSelectedSplitOptions: Dispatch<SetStateAction<PropertyGroupSplitBy[]>>;
  enableOwnerSelection?: boolean;
}) => {
  const dictionary = useUnitsPropertiesDictionary();

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h1 className="text-2xl font-bold">
          How would you like to group the {dictionary.properties}?
        </h1>
        <p className="text-sm text-content-400">You can select up to 3</p>
      </div>

      <PropertyGroupSelector
        selectedSplitOptions={selectedSplitOptions}
        setSelectedSplitOptions={setSelectedSplitOptions}
        enableOwnerSelection={enableOwnerSelection}
      />

      {selectedSplitOptions.length ? (
        <Card>
          <div className="flex items-center justify-between py-4 px-6 border-b border-content-100">
            <span className="text-xl font-bold">Example</span>

            <div className="flex gap-4 items-center">
              {PropertyGroupChartLegendItems.map((item, index) => (
                <div key={index} className="flex items-center gap-2">
                  <span className={`size-2 rounded-full ${item.color}`} />
                  <p className="text-xs text-content-400 font-medium">
                    {item.label === "Segments"
                      ? "Segments"
                      : `${dictionary.Property} groups`}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="h-[500px] flex flex-col items-center justify-center opacity-50">
            <PropertyGroupsSankeyChart
              key={selectedSplitOptions.join(",")}
              currentStep={PropertyGroupStep.INITIAL_CONFIGURATION}
              selectedSplitOptions={selectedSplitOptions}
              data={generateExampleSankeyData(selectedSplitOptions, dictionary)}
            />
          </div>
        </Card>
      ) : null}
    </div>
  );
};
